const config = {
  apiUrl: import.meta.env.VITE_API_URL,
  homeUrl: import.meta.env.VITE_HOME_URL,
  termOfServiceUrl: import.meta.env.VITE_TERM_OF_SERVICE_URL,
  privacyPolicyUrl: import.meta.env.VITE_PRIVACY_POLICY_URL,
  awsBucket: import.meta.env.VITE_AWS_BUCKET,
  googleOAuthClientId: import.meta.env.VITE_GOOGLE_OAUTH_CLIENT_ID,
  azureADClientId: import.meta.env.VITE_AZURE_AD_CLIENT_ID,
  googleWorkspaceClientId: import.meta.env.VITE_GOOGLE_WORKSPACE_CLIENT_ID,
};

export default config;
